module.exports = __webpack_public_path__ + "img/googleLogo.59643818.svg";